export const pushToDataLayer = (event: string, data?: Record<string, any>) => {
    if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];

        if (event === "cookie_consent_update") {
            const alreadyPushed = window.dataLayer.some((e: any) => e.event === "cookie_consent_update");
            if (alreadyPushed) return;
        }

        window.dataLayer.push({ event, ...data });
    }
};

export const pushConsentStatusToDataLayer = () => {
    if (typeof window === "undefined") return;

    const getCookieValue = (name: string) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        return match ? decodeURIComponent(match[2]) : "";
    };

    const granted = (key: string) => {
        const consentCookie = getCookieValue("cookie_consent"); // ex: "analytics,marketing"
        const gdprCookie = getCookieValue(`gdpr_settings_${key}`);
        const storageCookie = getCookieValue(`${key}_storage`);

        if (
            consentCookie
                .split(",")
                .map((s) => s.trim())
                .includes(key)
        )
            return "granted";
        if (gdprCookie === "granted") return "granted";
        if (storageCookie === "granted") return "granted";
        return "denied";
    };

    pushToDataLayer("cookie_consent_update", {
        consent: {
            ad_storage: granted("marketing"),
            analytics_storage: granted("analytics"),
            ad_user_data: granted("marketing"),
            ad_personalization: granted("marketing"),
            functionality_storage: "granted",
            personalization_storage: granted("marketing"),
            security_storage: "granted",
        },
    });
};
